
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import Home from '@/components/Home.vue'
import Puzzle from '@/components/Puzzle.vue'
import Rule from '@/components/Rule.vue'
import Line from '@/components/Line.vue'
import Message from '@/components/Message.vue'
import Share from '@/components/Share.vue'

export default defineComponent({
    computed: {
        ...mapState(['activityData', 'page', 'ruleShow', 'lineShow', 'shareImgData', 'messageData'])
    },
    components: {
        Home,
        Puzzle,
        Rule,
        Line,
        Message,
        Share
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false)

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            nextTick(() => {
                isApp.value && COVER.getUser((res: any) => {
                    $store.commit('SET_USERINFO', res)
                })
            })

            COVER.track('load', $store.state.activityData.title)
            COVER.onshare($store.state.shareData)
        })    

        return {
            isApp
        }
    }
})
